'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Estimate = void 0;
var $ = require("jquery");
var Estimate = /** @class */ (function () {
    function Estimate() {
        var _this = this;
        this.targetAmount = 0;
        this.scaleAmount = 0;
        this.basicAmount = 0;
        this.subtotal = 0;
        $('.trigShowVolume').on('input', function (e) {
            var volumeVal = $(e.currentTarget).val();
            if (Number(volumeVal) > 0 && !/^0/.test(volumeVal)) {
                $('.bulletShowVolume').text(volumeVal);
            }
            _this.showMain();
        });
        $('.trigShowTargetType').on('click', function (e) {
            var radioId = Number($(e.currentTarget).attr('data-radio-id'));
            switch (radioId) {
                case 0:
                    $('.bulletShowTargetType').text('市街地');
                    break;
                case 1:
                    $('.bulletShowTargetType').text('都市近郊');
                    break;
                case 2:
                    $('.bulletShowTargetType').text('耕地');
                    break;
            }
            _this.choiceRadio('.bulletChoiceTarget', radioId);
        });
        $('.trigShowScaleType').on('click', function (e) {
            var radioId = Number($(e.currentTarget).attr('data-radio-id'));
            switch (radioId) {
                case 0:
                    $('.bulletShowScaleType').text('1/500');
                    break;
                case 1:
                    $('.bulletShowScaleType').text('1/1000');
                    break;
                case 2:
                    $('.bulletShowScaleType').text('1/2500');
                    break;
            }
            _this.choiceRadio('.bulletChoiceScale', radioId);
        });
        this.showUnitPrice('.trigShowTargetUnitPrice', '.bulletShowTargetUnitPrice');
        this.showUnitPrice('.trigShowScaleUnitPrice', '.bulletShowScaleUnitPrice');
    }
    // ラジオボタンの代替
    Estimate.prototype.choiceRadio = function (bulletSelecter, radioId) {
        $(bulletSelecter).attr('data-choice', '0');
        $(bulletSelecter).eq(radioId).attr('data-choice', '1');
    };
    // 単価表示
    Estimate.prototype.showUnitPrice = function (trigSelecter, bulletSelecter) {
        var _this = this;
        $(trigSelecter).on('click', function (e) {
            var unitPrice = Number($(e.currentTarget).attr('data-price'));
            $(bulletSelecter).text(_this.comma(unitPrice));
            _this.showMain();
        });
    };
    Estimate.prototype.showMain = function () {
        var volumeVal = $('.trigShowVolume').val();
        var targetVal = $('input[name="map_target"]:checked').attr('data-price');
        var scaleVal = $('input[name="scale"]:checked').attr('data-price');
        if (Number(volumeVal) > 0 && !/^0/.test(volumeVal)) {
            if (targetVal !== undefined && scaleVal == undefined) {
                $('.bulletShowTargetAmount').text(this.comma(volumeVal * Number(targetVal)));
                $('.bulletShowScaleAmount').text('-');
                $('.bulletShowBasicUnitPrice').text('-');
                $('.bulletShowBasicAmount').text('-');
                $('.bulletShowSubtotal').text('-');
                $('.bulletShowConsumptionTax').text('-');
                $('.bulletShowTotal').text('-');
                // hidden
                $('.bulletHiddenBasicAmount').text('');
                $('.bulletHiddenSubtotal').text('');
                $('.bulletHiddenConsumptionTax').text('');
                $('.bulletHiddenTotal').text('');
            }
            else if (targetVal == undefined && scaleVal !== undefined) {
                $('.bulletShowTargetAmount').text('-');
                $('.bulletShowScaleAmount').text(this.comma(volumeVal * Number(scaleVal)));
                $('.bulletShowBasicUnitPrice').text('-');
                $('.bulletShowBasicAmount').text('-');
                $('.bulletShowSubtotal').text('-');
                $('.bulletShowConsumptionTax').text('-');
                $('.bulletShowTotal').text('-');
                // hidden
                $('.bulletHiddenBasicAmount').text('');
                $('.bulletHiddenSubtotal').text('');
                $('.bulletHiddenConsumptionTax').text('');
                $('.bulletHiddenTotal').text('');
            }
            else if (targetVal !== undefined && scaleVal !== undefined) {
                this.targetAmount = volumeVal * Number(targetVal);
                this.scaleAmount = volumeVal * Number(scaleVal);
                $('.bulletShowTargetAmount').text(this.comma(this.targetAmount));
                $('.bulletShowScaleAmount').text(this.comma(this.scaleAmount));
                this.showBasicUnitPrice(this.targetAmount, this.scaleAmount);
            }
        }
        else {
            $('.bulletShowVolume').text('-');
            $('.bulletShowTargetAmount').text('-');
            $('.bulletShowScaleAmount').text('-');
            $('.bulletShowBasicUnitPrice').text('-');
            $('.bulletShowBasicAmount').text('-');
            $('.bulletShowSubtotal').text('-');
            $('.bulletShowConsumptionTax').text('-');
            $('.bulletShowTotal').text('-');
            // hidden
            $('.bulletHiddenBasicAmount').text('');
            $('.bulletHiddenSubtotal').text('');
            $('.bulletHiddenConsumptionTax').text('');
            $('.bulletHiddenTotal').text('');
        }
    };
    // 基本料金表示
    Estimate.prototype.showBasicUnitPrice = function (targetAmount, scaleAmount) {
        var total = targetAmount + scaleAmount;
        var basicUnitPrice;
        if (1 <= total && total < 30000) {
            basicUnitPrice = 50000;
        }
        else if (30000 <= total && total < 35000) {
            basicUnitPrice = 45000;
        }
        else if (35000 <= total && total < 40000) {
            basicUnitPrice = 40000;
        }
        else if (40000 <= total && total < 45000) {
            basicUnitPrice = 35000;
        }
        else if (45000 <= total && total < 50000) {
            basicUnitPrice = 35000;
        }
        else if (50000 <= total) {
            basicUnitPrice = 30000;
        }
        this.basicAmount = basicUnitPrice * 1;
        $('.bulletShowBasicUnitPrice').text(this.comma(basicUnitPrice));
        $('.bulletShowBasicAmount').text(this.comma(this.basicAmount));
        $('.bulletHiddenBasicAmount').val(this.basicAmount);
        this.showSubtotal(this.targetAmount, this.scaleAmount, this.basicAmount);
    };
    // 小計表示
    Estimate.prototype.showSubtotal = function (targetAmount, scaleAmount, basicAmount) {
        this.subtotal = targetAmount + scaleAmount + basicAmount;
        $('.bulletShowSubtotal').text(this.comma(this.subtotal));
        $('.bulletHiddenSubtotal').val(this.subtotal);
        this.showConsumptionTax(this.subtotal, 10);
    };
    // 消費税表示
    Estimate.prototype.showConsumptionTax = function (subtotal, tax) {
        var consumptionTax = Math.round(subtotal * (tax / 100));
        $('.bulletShowConsumptionTax').text(this.comma(consumptionTax));
        $('.bulletHiddenConsumptionTax').val(consumptionTax);
        this.showTotal(subtotal, consumptionTax);
    };
    // 合計表示
    Estimate.prototype.showTotal = function (subtotal, consumptionTax) {
        var total = subtotal + consumptionTax;
        $('.bulletShowTotal').text(this.comma(total));
        $('.bulletHiddenTotal').val(total);
    };
    // 3桁カンマ区切り
    Estimate.prototype.comma = function (num) {
        return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    };
    return Estimate;
}());
exports.Estimate = Estimate;
exports.default = Estimate;
